import Daniella1 from '../Daniella/Daniella (1).webp'
import Daniella2 from '../Daniella/Daniella (2).webp'
import Daniella3 from '../Daniella/Daniella (3).webp'
import Daniella4 from '../Daniella/Daniella (4).webp'
import Daniella5 from '../Daniella/Daniella (5).webp'
import Daniella6 from '../Daniella/Daniella (6).webp'



const Daniellaimages =[
Daniella1,Daniella2,Daniella3,Daniella4,Daniella5,Daniella6
]

export default Daniellaimages;